<div class="u-relative u-maxX" [zipBusy]="gettingSubsidy">
  <div class="subsidy--toggle" data-test-id="subsidyFormGroupWrapper">
    <form-group
      data-test-id="subsidyFormGroup"
      [form]="showSubsidyFormGroup"
      [configs]="[subsidyControl]"
    >
    </form-group>
  </div>

  @if (isSubsidySelected) {
    <card data-test-id="subsidyCardWrapper">
      <div data-test-id="subsidyCardBody" body>
        <div
          class="demographics__form"
          data-test-id="subsidyDemographicsFormGroupWrapper"
        >
          <form-group
            data-test-id="subsidyDemographicsFormGroup"
            [form]="form"
            [configs]="config.controls"
          >
          </form-group>
        </div>
        <zip-button
          (zipButtonClicked)="submitSubsidyCalculator()"
          [disabled]="!form.valid"
          [content]="config.button.content"
          [level]="config.button.level || 'medium'"
          data-test-id="subsidyCalculatorSubmitButton"
        >
        </zip-button>
        @if (subsidy_result) {
          <div
            class="demographics__subsidy__result"
            data-test-id="subsidyDemographicsResultWrapper"
          >
            <p
              class="t-data t-bold"
              data-test-id="subsidyDemographicsResultTitle"
            >
              {{ resultsTitle }}
            </p>
            <p
              class="t-data"
              data-test-id="subsidyDemographicsResult"
              [innerHTML]="subsidy_result"
            ></p>
          </div>
        } @else {
          @if (!state_subsidy_amount && subsidy_text && subsidy_note) {
            <div
              class="demographics__subsidy__result"
              data-test-id="subsidyTextNoteWrapper"
            >
              <p class="t-data t-bold" data-test-id="subsidyResultTitle">
                {{ resultsTitle }}
              </p>
              <p class="t-data" data-test-id="subsidyTextNote">
                {{ subsidy_text }}<span>{{ subsidyDisplay }}. </span
                >{{ subsidy_note }}
              </p>
            </div>
          }
          @if (state_subsidy_amount) {
            <state-subsidy-results
              [config]="stateSubsidyConfig"
              [amount]="subsidy_amount"
              [federal_subsidy_amount]="federal_subsidy_amount"
              [state_subsidy_amount]="state_subsidy_amount"
              data-test-id="subsidyStateAmountResult"
            ></state-subsidy-results>
          }
        }
      </div>
    </card>
  }
</div>
